import Vue from 'vue';

const success = (data, context) => {
  context.stripe = Stripe(data.publicKey);
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, webKey, propertyKey) => Vue.$http.get(`/get-user-stripe-key/${webKey}/${propertyKey}`).then((response) => {
  if (response && response.status === 200) {
    success(response.data, context);
  }
}).catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/account/getConnectedStripePublicKey.js